import { BaseListModel } from "../base/base-list-model";
import { PaymentsFileFModel } from "./payments-file.model";

export const PaymentsFilesListModel =
  BaseListModel(PaymentsFileFModel).named("Payments");
